// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true,valid_types=protovalidate_required"
// @generated from file proto/v1/dropbox.proto (package vmspdb.api.proto.v1, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH

import type { Message } from '@bufbuild/protobuf';
import type {
  GenFile,
  GenMessage,
  GenService,
} from '@bufbuild/protobuf/codegenv2';
import {
  fileDesc,
  messageDesc,
  serviceDesc,
} from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file proto/v1/dropbox.proto.
 */
export const file_proto_v1_dropbox: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChZwcm90by92MS9kcm9wYm94LnByb3RvEhN2bXNwZGIuYXBpLnByb3RvLnYxIjUKHkRyb3Bib3hTZXJ2aWNlQ29uZmlndXJlUmVxdWVzdBITCgtjdXJyZW50X3VybBgBIAEoCSI3Ch9Ecm9wYm94U2VydmljZUNvbmZpZ3VyZVJlc3BvbnNlEhQKDHJlZGlyZWN0X3VybBgBIAEoCSIrChxEcm9wYm94U2VydmljZVBlcnNpc3RSZXF1ZXN0EgsKA3VybBgBIAEoCSIfCh1Ecm9wYm94U2VydmljZVBlcnNpc3RSZXNwb25zZTL+AQoORHJvcGJveFNlcnZpY2USeAoJQ29uZmlndXJlEjMudm1zcGRiLmFwaS5wcm90by52MS5Ecm9wYm94U2VydmljZUNvbmZpZ3VyZVJlcXVlc3QaNC52bXNwZGIuYXBpLnByb3RvLnYxLkRyb3Bib3hTZXJ2aWNlQ29uZmlndXJlUmVzcG9uc2UiABJyCgdQZXJzaXN0EjEudm1zcGRiLmFwaS5wcm90by52MS5Ecm9wYm94U2VydmljZVBlcnNpc3RSZXF1ZXN0GjIudm1zcGRiLmFwaS5wcm90by52MS5Ecm9wYm94U2VydmljZVBlcnNpc3RSZXNwb25zZSIAQipaKGdvLnZtc3BkYi5hcHAvcGxhdGZvcm0vaW50ZXJuYWwvcHJvdG8vdjFiBnByb3RvMw',
  );

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServiceConfigureRequest
 */
export type DropboxServiceConfigureRequest =
  Message<'vmspdb.api.proto.v1.DropboxServiceConfigureRequest'> & {
    /**
     * @generated from field: string current_url = 1;
     */
    currentUrl: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServiceConfigureRequest
 */
export type DropboxServiceConfigureRequestJson = {
  /**
   * @generated from field: string current_url = 1;
   */
  currentUrl?: string;
};

export type DropboxServiceConfigureRequestValid =
  DropboxServiceConfigureRequest;

/**
 * Describes the message vmspdb.api.proto.v1.DropboxServiceConfigureRequest.
 * Use `create(DropboxServiceConfigureRequestSchema)` to create a new message.
 */
export const DropboxServiceConfigureRequestSchema: GenMessage<
  DropboxServiceConfigureRequest,
  {
    jsonType: DropboxServiceConfigureRequestJson;
    validType: DropboxServiceConfigureRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_dropbox, 0);

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServiceConfigureResponse
 */
export type DropboxServiceConfigureResponse =
  Message<'vmspdb.api.proto.v1.DropboxServiceConfigureResponse'> & {
    /**
     * @generated from field: string redirect_url = 1;
     */
    redirectUrl: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServiceConfigureResponse
 */
export type DropboxServiceConfigureResponseJson = {
  /**
   * @generated from field: string redirect_url = 1;
   */
  redirectUrl?: string;
};

export type DropboxServiceConfigureResponseValid =
  DropboxServiceConfigureResponse;

/**
 * Describes the message vmspdb.api.proto.v1.DropboxServiceConfigureResponse.
 * Use `create(DropboxServiceConfigureResponseSchema)` to create a new message.
 */
export const DropboxServiceConfigureResponseSchema: GenMessage<
  DropboxServiceConfigureResponse,
  {
    jsonType: DropboxServiceConfigureResponseJson;
    validType: DropboxServiceConfigureResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_dropbox, 1);

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServicePersistRequest
 */
export type DropboxServicePersistRequest =
  Message<'vmspdb.api.proto.v1.DropboxServicePersistRequest'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string;
  };

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServicePersistRequest
 */
export type DropboxServicePersistRequestJson = {
  /**
   * @generated from field: string url = 1;
   */
  url?: string;
};

export type DropboxServicePersistRequestValid = DropboxServicePersistRequest;

/**
 * Describes the message vmspdb.api.proto.v1.DropboxServicePersistRequest.
 * Use `create(DropboxServicePersistRequestSchema)` to create a new message.
 */
export const DropboxServicePersistRequestSchema: GenMessage<
  DropboxServicePersistRequest,
  {
    jsonType: DropboxServicePersistRequestJson;
    validType: DropboxServicePersistRequestValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_dropbox, 2);

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServicePersistResponse
 */
export type DropboxServicePersistResponse =
  Message<'vmspdb.api.proto.v1.DropboxServicePersistResponse'> & {};

/**
 * @generated from message vmspdb.api.proto.v1.DropboxServicePersistResponse
 */
export type DropboxServicePersistResponseJson = {};

export type DropboxServicePersistResponseValid = DropboxServicePersistResponse;

/**
 * Describes the message vmspdb.api.proto.v1.DropboxServicePersistResponse.
 * Use `create(DropboxServicePersistResponseSchema)` to create a new message.
 */
export const DropboxServicePersistResponseSchema: GenMessage<
  DropboxServicePersistResponse,
  {
    jsonType: DropboxServicePersistResponseJson;
    validType: DropboxServicePersistResponseValid;
  }
> = /*@__PURE__*/ messageDesc(file_proto_v1_dropbox, 3);

/**
 * @generated from service vmspdb.api.proto.v1.DropboxService
 */
export const DropboxService: GenService<{
  /**
   * @generated from rpc vmspdb.api.proto.v1.DropboxService.Configure
   */
  configure: {
    methodKind: 'unary';
    input: typeof DropboxServiceConfigureRequestSchema;
    output: typeof DropboxServiceConfigureResponseSchema;
  };
  /**
   * @generated from rpc vmspdb.api.proto.v1.DropboxService.Persist
   */
  persist: {
    methodKind: 'unary';
    input: typeof DropboxServicePersistRequestSchema;
    output: typeof DropboxServicePersistResponseSchema;
  };
}> = /*@__PURE__*/ serviceDesc(file_proto_v1_dropbox, 0);
